export default __webpack_public_path__ + "static/media/REACTIF ET PRODUIT CHIMIQUE.9bbfe910.svg";